import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose, withApollo } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import s from './NewListing.css';
import l from '../../Skeleton/Skeleton.css';

// Components
import SeeAll from '../SeeAll';
import HomeSlider from '../HomeSlider';

// Skeleton Loader
import Shimmer from "../../Skeleton/Shimmer";
import HomeSliderSkleton from "../../Skeleton/HomeSliderSkleton";

// Graphql
import getNewListingsQuery from './getNewListings.graphql';

// Locale
import messages from '../../../locale/messages';

class NewListing extends React.Component {
    static propTypes = {
        getNewListingsData: PropTypes.shape({
            loading: PropTypes.bool,
            getNewListings: PropTypes.array
        }),
        skeletonArray: PropTypes.arrayOf(PropTypes.number)
    };

    static defaultProps = {
        getNewListingsData: {
            loading: true
        },
        skeletonArray: [1, 2, 3, 4, 5]
    };

    getTitleMessage = (category) => {
        switch (category) {
            case 'posada':
                return messages.newPosadas;
            case 'experience':
                return messages.newExperiences;
            case 'boat':
            default:
                return messages.newBoats;
        }
    };

    render() {
        const { getNewListingsData, skeletonArray, activeCategory } = this.props;
        const titleMessage = this.getTitleMessage(activeCategory);

        return (
            <>
                {getNewListingsData && getNewListingsData.loading ? (
                    <div className={s.pageContainer}>
                        <div className={cx(s.container, 'containerLoaderRTL')}>
                            <div className={cx(l.popularSkeletonTitle, 'bgBlackTwo')}>
                                <Shimmer />
                            </div>
                            <div className={s.displayGrid}>
                                {skeletonArray.map((n) => (
                                    <HomeSliderSkleton key={n} />
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        {getNewListingsData?.getNewListings?.length > 0 && (
                            <div className={s.container}>
                                <div className={s.pageContainer}>
                                    <div className={s.sectionHeader}>
                                        <h2 className={s.containerTitle}>
                                            <FormattedMessage {...titleMessage} />
                                        </h2>
                                        <SeeAll />
                                    </div>
                                    <HomeSlider data={getNewListingsData.getNewListings} />
                                </div>
                            </div>
                        )}
                    </>
                )}
            </>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s, l),
    withApollo,
    graphql(getNewListingsQuery, {
        name: 'getNewListingsData',
        options: (props) => ({
            variables: {
                categoryType: props.activeCategory || 'boat',
                limit: 12
            },
            ssr: false,
            fetchPolicy: 'network-only'
        })
    })
)(NewListing);
